/**
 * project_input_keys.description 파싱 헬퍼.
 *
 * description 은 JSON 문자열로, 두 가지 형태를 가진다:
 *  - locale별 HTML 객체: { ko, en, ca }
 *  - 단순 문자열
 *
 * 기준 상시 노출(ProjectInputForm)과 진행 전 재확인(InputConfirmModal)이
 * 동일한 파싱/렌더 소스를 쓰도록 공용화한다.
 */
export function parseInputKeyDescription(description) {
    if (!description) return {type: 'unknown', value: '-'};

    let parsed;
    try {
        parsed = JSON.parse(description);
    } catch (e) {
        // JSON 이 아니면 평문으로 취급
        return {type: 'string', value: description};
    }

    if (typeof parsed === 'string') return {type: 'string', value: parsed};
    if (parsed && typeof parsed === 'object') return {type: 'object', value: parsed};
    return {type: 'unknown', value: parsed};
}

/**
 * 현재 locale 에 맞는 description HTML 문자열을 반환한다.
 * 표시할 내용이 없으면 '' (falsy) 를 반환 → 호출부에서 "표시 안 함" 신호로 사용.
 */
export function inputKeyDescriptionHtml(input_key, locale) {
    const parsed = parseInputKeyDescription(input_key?.description);
    if (parsed.type === 'object') return parsed.value?.[locale] || parsed.value?.ko || '';
    if (parsed.type === 'string') return parsed.value || '';
    return '';
}
